module.exports = __webpack_public_path__ + "static/better-employee-04-540w-b65de5b8ceab6a997ac997d6f77e86ad.jpg";